import { phoneSymbolsClearRegex } from '@/constants/regex';
import { IUpdateOrderClientDTO } from '@/models/orders.model';

class UpdateClientDTO implements IUpdateOrderClientDTO {
  contact_name: string;
  contact_phone: string;
  contact_email: string;
  description?: string;

  constructor({ contact_name, contact_phone, contact_email, description }: IUpdateOrderClientDTO) {
    this.contact_name = contact_name;
    this.contact_phone = contact_phone?.replace(phoneSymbolsClearRegex, '');
    this.contact_email = contact_email;
    this.description = description;
  }
}

export default UpdateClientDTO;
